import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function Industries() {
	return (
		<>
			<Helmet>
				<title>Industries • Appex Connect Hub</title>
				<meta name="description" content="Industries we serve for compliant financial lead referrals: construction, transportation, healthcare, consumer lending." />
			</Helmet>
			<PageHeader
				title="Industries We Serve"
				subtitle="Construction-first focus with adjacent verticals across equipment, lending, and field services."
			/>
			<section className="section">
				<div className="container">
				<div className="grid grid-3">
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 18h14M7 18v-7l5-4 5 4v7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
						</div>
						<h3>Construction & Trades</h3>
						<p className="helper">Equipment and asset financing interest for builders, contractors, and specialty trades.</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 16h16M6 13l3-7h6l3 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
						</div>
						<h3>Transportation</h3>
						<p className="helper">Owner-operators and fleets seeking vehicle and equipment programs.</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 6h10l1 4H6l1-4Z" stroke="currentColor" strokeWidth="1.5"/><path d="M6 10h12v5H6v-5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 15v2m6-2v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Healthcare & Dental</h3>
						<p className="helper">Practices seeking equipment upgrades and patient financing referrals.</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 10h12v8H6v-8Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 10V7a3 3 0 0 1 6 0v3" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<h3>Consumer Lending</h3>
						<p className="helper">Personal, auto, and mortgage introductions to vetted providers.</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 16h16M5 12h14M8 8h8l1 4H7l1-4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
						</div>
						<h3>Manufacturing</h3>
						<p className="helper">Capital equipment for production and operations scale-up.</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6h12v12H6V6Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9h6v6H9V9Z" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<h3>Franchise & Retail</h3>
						<p className="helper">Multi-location needs with transparent disclosures and consent tracking.</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 15v-2l7-6 7 6v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M5 15h14v4H5v-4Z" stroke="currentColor" strokeWidth="1.5"/></svg>
						</div>
						<h3>Renovation & Remodeling</h3>
						<p className="helper">Residential and commercial renovation programs with clear homeowner communications.</p>
					</div>
					<div className="card feature">
						<div className="icon-circle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 15h16M7 11h10M9 7h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M5 15 9 7l6 8 4-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
						</div>
						<h3>Energy & Solar</h3>
						<p className="helper">Solar and efficiency upgrades with opt-in appointment scheduling and updates.</p>
					</div>
				</div>
				</div>
			</section>
		</>
	);
}

export default Industries;


